export default __webpack_public_path__ + "static/Tek_Dedicated_Storage-4d432ebd049c34c1ffdb99a7fdb2c6c6.png";